import { render } from "./ExpensesType.vue?vue&type=template&id=4eeec8e0&ts=true"
import script from "./ExpensesType.vue?vue&type=script&lang=ts"
export * from "./ExpensesType.vue?vue&type=script&lang=ts"

import "./ExpensesType.vue?vue&type=style&index=0&id=4eeec8e0&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__